import { render, staticRenderFns } from "./AsideComponent.vue?vue&type=template&id=552d3da4&scoped=true"
import script from "./AsideComponent.vue?vue&type=script&lang=js"
export * from "./AsideComponent.vue?vue&type=script&lang=js"
import style0 from "./AsideComponent.vue?vue&type=style&index=0&id=552d3da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552d3da4",
  null
  
)

export default component.exports